/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';
import TableGrid from '../../../SharedModules/Table/TableGridWithFeatures';
import { CMSReporting, CMSUtilization } from './tablehead';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../SharedModules/AgGridUtilities/suppressNavigation';
import SaveCancelPopup from '../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';

const GroupTab = (props) => {
  const dispatch = useDispatch();
  const {
    gridData,
    cmsReportFrameworkComponents,
    cmsUtilFrameworkComponents,
    grpRecordAdd,
    grpRecordDelete,
    handleFullScreen,
    isEnablebyRole,
  } = props;
  const [cmsReporting, setCmsReporting] = React.useState([]);
  const [cmsUtilization, setCmsUtilization] = React.useState([]);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [deleteMsg, setDeleteMsg] = React.useState('');
  const [rptFullScreen, setRptFullScreen] = React.useState(false);
  const [utilFullScreen, setUtilFullScreen] = React.useState(false);

  React.useEffect(() => {
    if (gridData) {
      let { cmsReporting, cmsUtilization } = gridData;
      if (cmsReporting) setCmsReporting([...cmsReporting]);
      if (cmsUtilization) setCmsUtilization([...cmsUtilization]);
    }
  }, [gridData]);

  return (
    <>
      {!utilFullScreen && (
        <fieldset className="custom-fieldset mt-3" style={{ height: 'auto' }}>
          <legend className="same-font-family">CMS Reporting</legend>
          {/* {!rptFullScreen && (
            <div className="btn-wrapper mb-2">
              <div className="float-right">
                <Button
                  className="btn btn-success"
                  onClick={() => grpRecordAdd('cmsrpt')}
                >
                  <SVGComponent iconName="Icon-outline-add-circle" /> Add
                </Button>
                <Button
                  className="btn btn-cancel"
                  onClick={() => {
                    if (
                      cmsReporting.filter((o) => o.delete === true).length > 0
                    ) {
                      setDeleteModal(true);
                      setDeleteMsg('cmsrpt');
                    }
                  }}
                >
                  <SVGComponent iconName="Icon-delete" /> Delete
                </Button>
              </div>
            </div>
          )} */}
          <div className="clearfix" />
          <TableGrid
            data-testid="cmsreporting"
            rowData={cmsReporting}
            gridHeight={rptFullScreen ? '70vh' : 360}
            handleFullScreenViewClick={() => {
              setRptFullScreen(!rptFullScreen);
              handleFullScreen(!rptFullScreen);
            }}
            noGlobalSort
            fullScreenView={rptFullScreen}
            hideColumnsInPdf={['delete']}
            addButtonText="Add CMS Reporting"
            handleAddNewRow={
              isEnablebyRole ? (e) => grpRecordAdd('cmsrpt') : ''
            }
            columnDefs={CMSReporting}
            navigateToNextCell={navigateToNextCell}
            // tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            exportFile
            isScrollOn
            fileName="CMS Reporting"
            onCellFocused={onCellFocused}
            frameworkComponents={cmsReportFrameworkComponents}
          />
          <div className="clearfix" />
        </fieldset>
      )}
      {!rptFullScreen && (
        <fieldset className="custom-fieldset mt-3" style={{ height: 'auto' }}>
          <legend className="same-font-family">CMS Utilization</legend>
          {/* {!utilFullScreen && (
            <div className="btn-wrapper mb-2">
              <div className="float-right">
                <Button
                  className="btn btn-success"
                  onClick={() => grpRecordAdd('cmsutil')}
                >
                  <SVGComponent iconName="Icon-outline-add-circle" /> Add
                </Button>
                <Button
                  className="btn btn-cancel"
                  onClick={() => {
                    if (
                      cmsUtilization.filter((o) => o.delete === true).length > 0
                    ) {
                      setDeleteModal(true);
                      setDeleteMsg('cmsutil');
                    }
                  }}
                >
                  <SVGComponent iconName="Icon-delete" /> Delete
                </Button>
              </div>
            </div>
          )} */}
          <div className="clearfix" />
          <TableGrid
            data-testid="cmsutil"
            rowData={cmsUtilization}
            gridHeight={utilFullScreen ? '70vh' : 360}
            handleFullScreenViewClick={() => {
              setUtilFullScreen(!utilFullScreen);
              handleFullScreen(!utilFullScreen);
            }}
            noGlobalSort
            fullScreenView={utilFullScreen}
            hideColumnsInPdf={['delete']}
            disableAdd={ !isEnablebyRole}
            addButtonText="Add CMS Utilization"
            handleAddNewRow={(e) => grpRecordAdd('cmsutil')}
            columnDefs={CMSUtilization}
            navigateToNextCell={navigateToNextCell}
            // tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            exportFile
            fileName="CMS Utilization"
            onCellFocused={onCellFocused}
            frameworkComponents={cmsUtilFrameworkComponents}
          />
          <div className="clearfix" />
        </fieldset>
      )}
      {/* <SaveCancelPopup
        open={deleteModal}
        data-test="cancelPopup"
        title="Delete"
        onConfim={() => {
          setDeleteModal(false);
          grpRecordDelete(deleteMsg);
        }}
        onCancel={(e) => setDeleteModal(false)}
        moduleName={`selected row(s)`}
      /> */}
    </>
  );
};
export default GroupTab;
